import { useFormContext } from "react-hook-form";
import { z } from "zod";
import { FormField } from "@/components/ui";
import Dropdown, { formatDropdownOptions } from "@/components/ui/Dropdown";
import { useEffect, useState } from "react";
import { getMasterDropdownService } from "@/services/masters";

export const citySchema = z.object({
  City_Name: z.string().min(2, "City name must be at least 2 characters"),
  State: z.string().min(1, "Please select a state"),
});

export type CityFormData = z.infer<typeof citySchema>;
const AddCityForm = () => {
  const [states, setStates] = useState<any[]>([]);
  const [loadingStates, setLoadingStates] = useState(true);

  const {
    control,
    formState: { errors },
    clearErrors,
    getValues,
  } = useFormContext<CityFormData>();

  useEffect(() => {
    async function fetchStates() {
      try {
        const response = await getMasterDropdownService();
        if (response.data) {
          const data = response.data as any;
          if (data.States) {
            let statesData = data.States;

            // Add current state to options if it doesn't exist (handles data mismatches)
            const currentState = getValues("State");
            if (currentState && !statesData.some((s: any) => s.Name === currentState)) {
              statesData = [{ id: 'temp-state', Name: currentState }, ...statesData];
            }

            setStates(statesData);
          }
        }
      } catch (error) {
        // console.error("Failed to load states:", error);
      } finally {
        setLoadingStates(false);
      }
    }

    fetchStates();
  }, [getValues]);

  return (
    <div className="flex flex-col gap-4">
      <FormField
        control={control}
        name="City_Name"
        label="District Name"
        placeholder="Enter District Name"
        type="text"
        error={errors.City_Name?.message}
        onClear={() => clearErrors("City_Name")}
        required
      />

      <Dropdown
        name="State"
        label="State"
        options={formatDropdownOptions(states, "Name", "Name")}
        control={control}
        error={errors.State?.message}
        required
        isLoading={loadingStates}
        placeholder="Select a state"
        onClear={() => clearErrors("State")}
        maxHeight="100"
      />
    </div>
  );
};

export default AddCityForm;
